import {
  Menu as CXMenu,
  MenuItem as CXMenuItem,
  MenuProvider as CXMenuProvider
} from '@sanlamcx/react-ui-next-menu';

type Menu = typeof CXMenu;
type MenuItem = typeof CXMenuItem;
type MenuProvider = typeof CXMenuProvider;

export const Menu: Menu = CXMenu;
export const MenuItem: MenuItem = CXMenuItem;
export const MenuProvider: MenuProvider = CXMenuProvider;
